<template>
  <validation-observer tag="div" class="pt-1" v-slot="{handleSubmit}" ref="formObs">
    <form @submit.prevent="handleSubmit(next)">
      <v-row dense>
        <v-col md="2" sm="4" cols="12">
          <div class="passport-photo">
            <img class="passport-photo-img" :src="'https://api.icangroup.uz/storage/' + formData.passport_photo" v-if="formData.passport_photo">
            <img class="passport-photo-img" src="../../assets/images/no-passport-photo.jpg" alt="Нет фотографии" v-else>
          </div>
        </v-col>
        <v-col md="10" sm="12" cols="12">
          <v-row dense>
            <v-col md="4" sm="6" cols="12">
              <custom-input-text
                      label="ПИНФЛ"
                      name="ПИНФЛ"
                      v-mask="'##############'"
                      counter="14"
                      rules="required|pnfl"
                      vid="pnfl"
                      v-model="formData.pnfl"
              ></custom-input-text>
            </v-col>
            <v-col md="4" sm="6" cols="12">
              <div class="d-flex">
                <custom-input-text
                        always-uppercase
                        style="width: 180px;"
                        label="Серия паспорта"
                        name="Серия паспорта"
                        v-mask="'AA'"
                        counter="2"
                        rules="required"
                        vid="passport_series"
                        v-model="formData.passport_series"
                ></custom-input-text>
                <custom-input-text
                        label="Номер паспорта"
                        name="Номер паспорта"
                        v-mask="'#######'"
                        counter="7"
                        class="flex-grow-1 ml-2"
                        rules="required"
                        vid="passport_number"
                        v-model="formData.passport_number"
                ></custom-input-text>
              </div>
            </v-col>
            <v-col md="4" sm="6" cols="12">
              <v-btn :width="$vuetify.breakpoint.mdAndDown ? '100%' : null" color="success" type="button"
                     @click="$emit('getDigIdInfo')"
                     :loading="loading">Заполнить данные автоматический
              </v-btn>
            </v-col>
          <v-col md="4" sm="6" cols="12">
            <custom-input-text
                    always-uppercase
                    vid="last_name"
                    v-model="formData.last_name"
                    rules="required"
                    label="Фамилия"
                    name="Фамилия"
            ></custom-input-text>
          </v-col>
          <v-col md="4" sm="6" cols="12">
            <custom-input-text
                    always-uppercase
                    v-model="formData.first_name"
                    vid="first_name"
                    rules="required"
                    label="Имя"
                    name="Имя"
            ></custom-input-text>
          </v-col>
          <v-col md="4" sm="6" cols="12">
            <custom-input-text
                    always-uppercase
                    vid="middle_name"
                    v-model="formData.middle_name"
                    rules="required"
                    label="Отчество"
                    name="Отчество"
            ></custom-input-text>
          </v-col>
          <v-col md="4" sm="6" cols="12">
            <custom-select
                    vid="gender"
                    item-text="text"
                    item-value="value"
                    v-model="formData.gender"
                    :items="GENDERS"
                    rules="required"
                    label="Пол"
                    name="Пол"
            ></custom-select>
          </v-col>
          <v-col md="4" sm="6" cols="12">
            <custom-autocomplete
                    vid="region_id"
                    v-model="formData.region_id"
                    :items="regions"
                    @input="getDistrict"
                    rules="required"
                    label="Регион"
                    name="Регион"
            ></custom-autocomplete>
          </v-col>
          <v-col md="4" sm="6" cols="12">
            <custom-select
                    vid="district_id"
                    v-model="formData.district_id"
                    :loading="districtLoading"
                    :items="districts"
                    rules="required"
                    label="Район"
                    name="Район"
            ></custom-select>
          </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col md="4" sm="6" cols="12">
          <custom-input-text
              min="01-01-1957"
              max="01-01-2010"
              label="Дата рождения"
              name="Дата рождения"
              rules="required"
              vid="birth_day"
              type="date"
              v-model="formData.birth_day"
          ></custom-input-text>
        </v-col>
        <v-col md="4" sm="6" cols="12">
          <custom-input-text
              always-uppercase
              label="Место рождения"
              name="Место рождения"
              rules="required"
              vid="birth_address"
              v-model="formData.birth_address"
          ></custom-input-text>
        </v-col>
        <v-col md="4" sm="6" cols="12">
          <custom-input-text
              label="ИНН"
              name="ИНН"
              rules="required|inn"
              v-mask="'#########'"
              only="number"
              counter="9"
              vid="inn"
              v-model="formData.inn"
          ></custom-input-text>
        </v-col>
        <v-col md="4" sm="6" cols="12">
          <custom-input-text
              always-uppercase
              label="МФЙ"
              name="МФЙ"
              vid="address_mfy"
              v-model="formData.address_mfy"
          ></custom-input-text>
        </v-col>
        <v-col md="4" sm="6" cols="12">
          <custom-input-text
              always-uppercase
              label="Адрес проживания"
              name="Адрес проживания"
              vid="live_address"
              v-model="formData.live_address"
          ></custom-input-text>
        </v-col>
        <v-col md="4" sm="6" cols="12">
          <custom-input-text
              always-uppercase
              label="Адрес по паспорту"
              name="Адрес по паспорту"
              vid="passport_address"
              v-model="formData.passport_address"
          ></custom-input-text>
        </v-col>
        <v-col md="4" sm="6" cols="12">
          <custom-input-text
              min="01-01-1957"
              max="01-01-2010"
              label="Дата получения паспорта"
              name="Дата получения паспорта"
              vid="passport_issue_date"
              v-model="formData.passport_issue_date"
              type="date"
          ></custom-input-text>
        </v-col>
        <v-col md="4" sm="6" cols="12">
          <custom-input-text
              min="01-01-1957"
              max="01-01-2010"
              label="Срок годности паспорта"
              name="Срок годности паспорта"
              vid="passport_expiry_date"
              v-model="formData.passport_expiry_date"
              type="date"
          ></custom-input-text>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6" md="4">
          <div class="d-flex">
            <custom-input-text
                prefix="+998"
                pattern="##-###-##-##"
                label="Номер телефона"
                name="Номер телефона"
                rules="required|phone"
                vid="phone"
                class="flex-grow-1"
                v-model="formData.phone"
            ></custom-input-text>
            <btn-with-tooltip
                v-if="formData.phones.length < 2"
                @click="formData.phones.length < 2 ?formData.phones.push(null) : ()=>{}"
                class-name="action-btn ml-2 mt-1"
                color="primary">
              <v-icon small>fas fa-plus</v-icon>
              <template #tooltip>Добавить номер телефона</template>
            </btn-with-tooltip>
          </div>
        </v-col>
        <template v-for="(_, phoneIndex) in formData.phones" v-if="formData.phones.length">
          <v-col cols="12" sm="6" md="4">
            <div class="d-flex">
              <custom-input-text
                  prefix="+998"
                  pattern="##-###-##-##"
                  rules="required|phone"
                  class="flex-grow-1 mr-2"
                  v-model="formData.phones[phoneIndex]"
              ></custom-input-text>
              <btn-with-tooltip
                  @click="formData.phones.splice(phoneIndex, 1)"
                  class-name="action-btn ml-2 mt-1"
                  color="error">
                <v-icon small>fas fa-minus</v-icon>
                <template #tooltip>Удалить номер телефона</template>
              </btn-with-tooltip>
            </div>
          </v-col>
        </template>
      </v-row>
      <v-row dense>
        <v-col md="4" sm="6" cols="12">
          <custom-input-text
              label="Место работы"
              vid="work_place"
              v-model="formData.work_place"
          ></custom-input-text>
        </v-col>
        <v-col md="4" sm="6" cols="12">
          <custom-input-text
              label="Должность"
              vid="position"
              v-model="formData.position"
          ></custom-input-text>
        </v-col>

      </v-row>
      <div class="text-right">
        <v-btn :width="$vuetify.breakpoint.mdAndDown ? '100%' : null" color="primary" type="submit"
               :loading="loading">Далее
        </v-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
import {GENDERS} from "@/utils/constants";
import {refactorNumber} from "@/utils/pureFunctions";

export default {
  props: {
    user_id: {},
    regions: {
      type: Array
    },
    mko_id: {},
    formData: Object
  },
  data() {
    return {
      GENDERS,
      districtLoading: false,
      loading: false,
      districts: []
    }
  },
  methods: {
    async getDistrict(id, firstLoad = false) {
      this.districtLoading = true
      try {
        this.districts = await this.$store.dispatch('getDistrict', id)
        if (!firstLoad) {
          this.formData.district_id = null
        }
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.districtLoading = false
      }

    },
    refactoringNumbers(number) {
      return refactorNumber({prefix: '998', number, removeSymbol: '-'})
    },
    async next() {
      this.$showLoading()
      try {
        const formData = {...this.formData}
        formData.phones = formData.phones.map(this.refactoringNumbers)
        if (formData.phone) formData.phone = this.refactoringNumbers(formData.phone)
        formData.mko_id = this.mko_id
        if (this.user_id) {
          formData.user_id = this.user_id
        }
        const {data: {data}} = await this.$http.post('admin/credits/create/step-one', formData)
        if (data.gender) {
          const gender = GENDERS.find(item => item.text === data.gender)
          if (gender) {
            data.genderText = gender.text
            data.gender = gender.value
          }
        }
        this.$emit('apply', data)
      } catch (e) {
        this.$setResponseError({error: e})
        this.$setFormError({error: e, obs: this.$refs['formObs']})
      } finally {
        this.$clearLoading()
      }

    }
  }

}
</script>
<style>
  .passport-photo {
    width: 210px;
    height: 210px;
    border: solid #999 1px;
  }
  .passport-photo-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
</style>
